import { call, put } from "redux-saga/effects";
import * as types from "../consts";
import { updateTenant, updateUser, deleteTenant, getTenantDetail, getTenantsList } from "../api";
import { getProductList } from "../../product/api";
import { Product } from "../../../shared/interfaces/model/product.interface";
import { Tenant } from "../../../shared/interfaces/model/tenant.interface";

export function* getTenantDetailSaga({ payload }: ReturnType<typeof Object>) {
  try {
    const detailsTenant: object = yield call(getTenantDetail, payload);
    yield put({
      type: types.GET_TENANT_DETAIL_SUCCESS,
      response: detailsTenant,
    });
  } catch (error) {
    yield put({ type: types.GET_TENANT_DETAIL_ERROR, error });
  }
}

export function* getTenantsListSaga({ payload }: ReturnType<typeof Object>) {
  try {
    const productList: { products: Product[] } = yield call(getProductList, payload);
    const tenantsList: { tenants: Tenant[] } = yield call(getTenantsList, payload);
    const newTenantsList = tenantsList.tenants.map((tenant: Tenant) => {
      const products = tenant.product?.map((product: string) => {
        const productObj = productList.products.find((productItem: Product) =>
          productItem.appCode === product);
        return productObj?.name;
      });
      return {
        ...tenant,
        product: products,
      };
    });
    yield put({ type: types.GET_TENANTS_LIST_SUCCESS, response: { tenants: newTenantsList } });
  } catch (error) {
    yield put({ type: types.GET_TENANTS_LIST_ERROR, error });
  }
}

export function* deleteTenantRowSaga({ payload }: ReturnType<typeof Object>) {
  try {
    const tenantRow: object = yield call(deleteTenant, payload);
    yield put({ type: types.DELETE_TENANT_ROW_SUCCESS, response: tenantRow });
  } catch (error) {
    yield put({ type: types.DELETE_TENANT_ROW_ERROR, error });
  }
}

export function* updateTenantRowSaga({ payload }: ReturnType<typeof Object>) {
  try {
    const tenantRow: object = yield call(updateTenant, payload);
    yield put({ type: types.UPDATE_TENANT_ROW_SUCCESS, response: tenantRow });
  } catch (error) {
    yield put({ type: types.UPDATE_TENANT_ROW_ERROR, error });
  }
}

export function* updateUserRowSaga({ payload }: ReturnType<typeof Object>) {
  try {
    const userRow: object = yield call(updateUser, payload);
    yield put({ type: types.UPDATE_USER_V2_ROW_SUCCESS, response: userRow });
  } catch (error) {
    yield put({ type: types.UPDATE_USER_V2_ROW_ERROR, error });
  }
}
